<template>
  <div class="content my-info-frame">
    <div class="my-info-name">
      <div class="my-info-image">
        <i><img :src="vipInfo.currentVipImage" alt=""></i>
      </div>
      <div class="my-info-text">
        <span>
          {{ $t('Bao.personal_info_setting') }} : {{ memberInfo.nickname }}
        </span>
        <span>{{ vipInfo.currentVipName }}</span>
        <span v-if="vipInfo.last_update_date !== 0">
          {{ $t('Bao.last_update_date') }}: {{ last_update_date }}
        </span>
      </div>
    </div>
    <div class="my-lv-frame">
      <div class="keepvip_title">
        {{ $t('Bao.upgrade_require') }}
      </div>
      <ul class="my-lv">
        <li>
          <template v-if="vipInfo.upgradeNeedDepositAmount !== 0">
            <div class="my-turnover">
              <div><span>{{ $t('Bao.accumulate_deposit') }}</span></div>
              <div class="percent">
                <div
                  class="percent-current"
                  :style="{ 'width': upgrade_deposit_amount_percentage + '%' }"
                />
              </div>
              <div :class="upgradeDepositAmountClass" />
              <div class="shortOf">
                <span>{{ $t('Bao.short_of') }}</span><span> {{ currency }}{{ deposit_amount }}</span>
              </div>
            </div>
          </template>
          <template v-if="vipInfo.upgradeNeedPerformance !== 0">
            <div class="my-turnover">
              <div><span>{{ $t('Bao.accumulate_turnover') }}</span></div>
              <div class="percent">
                <div
                  class="percent-current"
                  :style="{ 'width': upgrade_performance_percentage + '%' }"
                />
              </div>
              <div :class="performanceClass" />
              <div class="shortOf">
                <span>{{ $t('Bao.short_of') }}</span><span> {{ currency }}{{ cumulative_flow }}</span>
              </div>
            </div>
          </template>
        </li>
      </ul>
    </div>
    <section class="my-section-frame">
      <div class="h5 fs-14px">
        {{ $t('Bao.personal_data') }}
      </div>
      <div class="my-money my-wallet-frame">
        <div class="my-wallet">
          <div class="wallwt-container">
            <div class="my-info-card-title">
              <div class="fs-6 fw-700">
                {{ $t('Bao.common_wallet') }}{{ $t('Bao.balance') }}
              </div>
              <div class="icon-refresh" @click="refreshGold()">
                <img v-if="!isRefreshingGold" class="refresh" :src="$getThemeImagePath('icon-refresh.png')" alt="refresh gold">
                <i v-else class="fa fa-spinner fa-pulse fa-fw" />
              </div>
            </div>
            <hr>
            <ul class="wallet-content">
              <li class="wallet-items wallet-tx">
                <div class="con-left">
                  <div class="icon-coin">
                    <img :src="getWalletImagePath(app.selectedWallet)" alt="">
                  </div>
                  <span class="text-align-R wallet-tx-xl tx-highlight">{{ getWalletBalance(app.selectedWallet) }}</span>
                </div>
                <div class="con-right">
                  <a class="detailed goTo-fun-detailed tx-highlight" @click.prevent="showWallet = true">
                    {{ $t('Bao.personal_detail') }}
                  </a>
                </div>
              </li>

              <li class="wallet-items">
                <div class="con-left">
                  <span class="text-align-R wallet-tx-xl ">
                    {{ $t('Bao.available_withdrawal_amount') }}
                  </span>
                </div>
                <div class="con-right">
                  <span class="t-highlight fs-14px tx-highlight">
                    {{ displayAvailPrice }}
                  </span>
                </div>
              </li>

              <li class="wallet-items">
                <div class="con-left">
                  <span class="text-align-R fs-14px">{{ $t('Bao.deposit_limit') }}</span>
                </div>
                <div class="con-right">
                  <span class="t-highlight fs-14px tx-highlight">{{ withdrawalLimit }}</span>
                </div>
              </li>
            </ul>

            <div class="my-wallet-BTN">
              <button v-if="$store.getters.canMemberDeposit" class="btn-nav-deposit" @click="$router.push('/deposit')">
                {{ $t('Bao.deposit') }}
              </button>
              <button class="btn-nav-withdrawal" @click="$router.push('/withdrawal')">
                {{ $t('Bao.withdrawal') }}
              </button>
            </div>
          </div>
        </div>

        <div v-if="!isOfflineAgentMember" class="my-wallet">
          <div class="wallwt-container">
            <div class="my-info-card-title fs-6 fw-700">
              {{ $t('Bao.bonus_gold') }}
            </div>
            <hr>
            <ul class="wallet-content">
              <li class="wallet-items wallet-tx bg-color">
                <div class="con-left">
                  <span class="wallet-tx-xl">{{ $t('Bao.balance') }}</span>
                </div>

                <div class="con-right">
                  <div class="icon-coin">
                    <img :src="getWalletImagePath(bonusWallet)" alt="">
                  </div>
                  <span class="text-align-R wallet-tx-xl t-highlight tx-highlight">{{ bonusWalletBalance | numberFormat }}</span>
                </div>
              </li>

              <li class="wallet-items">
                <div class="con-left">
                  <span class="align-center">
                    {{ $t('Bao.deposit_limit') }}
                    <i class="icon-infor" @click="showModel(permissionInfo.bonus_wallet_rule)">
                      <img :src="$getThemeImagePath('icon_uestion.svg')" alt="">
                    </i>
                  </span>
                </div>

                <div class="con-right">
                  <span class="text-align-R balance fs-14px tx-highlight">{{ bonus_transfer_limit | numberFormat }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div v-if="!isOfflineAgentMember" class="my-wallet">
          <div class="wallwt-container">
            <div class="my-info-card-title fs-6 fw-700">
              {{ $t('Bao.commission_gold') }}
            </div>
            <hr>
            <ul class="wallet-content">
              <li class="wallet-items wallet-tx bg-color">
                <div class="con-left">
                  <span class="wallet-tx-xl">{{ $t('Bao.balance') }}</span>
                </div>

                <div class="con-right">
                  <div class="icon-coin">
                    <img :src="getWalletImagePath(commissionWallet)" alt="">
                  </div>
                  <span class="text-align-R wallet-tx-xl t-highlight tx-highlight">
                    {{ commissionWalletBalance | numberFormat }}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="personal_area_txbox">
          <ol class="state_txbox">
            <li>{{ $t('Bao.cumulative_valid_wagers_principal_2') }}</li>
            <li>{{ $t('Bao.cumulative_valid_wagers_principal_3') }}</li>
          </ol>
        </div>

        <performance-modal :is-active="showModal" :limit-text="limitText" @hideModel="hideModel" />
      </div>
    </section>
    <personal-wallet-modal
      :is-active="showWallet"
      :avail-price="displayAvailPrice"
      :withdrawal-limit="withdrawalLimit"
      @hideWalletModal="hideWalletModal"
    />
  </div>
</template>

<script>
import { getWalletImagePath, getWalletBalance } from '@/utils/tool'
import { withdrawalWallet } from '@/api/payment'
import performanceModal from '@/components/modal/performanceModal'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'
import walletMixin from '@/mixins/walletMixin'
import PersonalWalletModal from '@/components/modal/personalWalletModal'

export default {
  components: {
    performanceModal,
    PersonalWalletModal
  },
  mixins: [themeMixin, walletMixin],
  data() {
    return {
      showModal: false,
      showWallet: false,
      limitText: '',
      performanceClass: '',
      upgradeDepositAmountClass: '',
      wallets: []
    }
  },
  computed: {
    ...mapGetters(['user', 'memberInfo', 'brand', 'permissionInfo', 'app', 'isOfflineAgentMember']),
    vipInfo() {
      return this.user.vipInfo
    },
    currency() {
      return this.brand.currency
    },
    last_update_date() {
      const last_update_time = this.vipInfo.last_upgrade_time
      return last_update_time === 0 ? 0 : this.$options.filters.dateFormat(last_update_time)
    },
    upgrade_deposit_amount_percentage() {
      const percentage = parseInt(this.vipInfo.upgradeCurrentDepositAmount) / parseInt(this.vipInfo.upgradeNeedDepositAmount) * 100
      return percentage > 100 ? 100 : percentage
    },
    upgrade_performance_percentage() {
      const percentage = parseInt(this.vipInfo.upgradeCurrentPerformance) / parseInt(this.vipInfo.upgradeNeedPerformance) * 100
      return percentage > 100 ? 100 : percentage
    },
    withdrawalLimit() {
      const wallet = this.app.selectedWallet
      if (wallet && wallet.withdrawal_limit) {
        const limit = parseFloat(wallet.withdrawal_limit) - parseFloat(wallet.turnover)
        // 去除小數末尾的 0
        return limit > 0 ? parseFloat(limit.toFixed(6)).toString() : '0'
      }

      return '0'
    },
    bonus_transfer_limit() {
      const wallet = this.bonusWallet
      if (wallet && wallet.withdrawal_limit) {
        const limit = parseFloat(wallet.withdrawal_limit) - parseFloat(wallet.turnover)
        return limit > 0 ? limit.toFixed(6) : '0'
      }

      return '0'
    },
    deposit_amount() {
      const amount = this.vipInfo.upgradeNeedDepositAmount - this.vipInfo.upgradeCurrentDepositAmount
      if (amount >= 0) {
        return this.$options.filters.numberFormat(amount)
      } else {
        return 0
      }
    },
    cumulative_flow() {
      const amount = this.vipInfo.upgradeNeedPerformance - this.vipInfo.upgradeCurrentPerformance
      if (amount >= 0) {
        return this.$options.filters.numberFormat(amount)
      } else {
        return 0
      }
    },
    displayAvailPrice() {
      if (
        !this.user || this.mainWalletBalance === undefined || this.withdrawalLimit === undefined
      ) {
        return ''
      }

      const selectedWallet = this.app.selectedWallet
      if (!selectedWallet || Object.keys(selectedWallet).length === 0) {
        return '0'
      } else if (selectedWallet.wallet_type === 'main') {
        return this.$options.filters.numberFormat(this.mainWalletBalance)
      } else if (selectedWallet.amount_limit) {
        return this.$options.filters.numberFormat(selectedWallet.amount_limit.max)
      }

      return '0'
    },
    bonusWallet() {
      return this.user.walletInfo.find(w => w.wallet_type === 'bonus') || {}
    },
    bonusWalletBalance() {
      return this.bonusWallet.balance || 0
    },
    mainWalletBalance() {
      const main = this.user.walletInfo.find(w => w.wallet_type === 'main')
      return main ? main.balance : 0
    },
    commissionWallet() {
      return this.user.walletInfo.find(w => w.wallet_type === 'commission') || {}
    },
    commissionWalletBalance() {
      return this.commissionWallet.balance || 0
    }
  },
  watch: {
    'app.selectedWallet': {
      immediate: true,
      handler(newWallet) {
        if (newWallet && newWallet.wallet_type) {
          const found = this.user.walletInfo.find(
            info => info.wallet_type === newWallet.wallet_type
          )
          if (found) {
            this.$set(this.app.selectedWallet, 'withdrawal_limit', found.withdrawal_limit)
            this.$set(this.app.selectedWallet, 'turnover', found.turnover)
          }

          if (this.wallets.length > 0) {
            const wallet = this.wallets.find(w => w.wallet_type === newWallet.wallet_type)
            if (wallet) {
              this.$set(this.app.selectedWallet, 'amount_limit', wallet.amount_limit)
            }
          }
        }
      }
    }
  },
  created() {
    withdrawalWallet().then((response) => {
      this.wallets = response.data.data
      if (this.wallets.length > 0) {
        const wallet = this.wallets.find(w => w.wallet_type === this.app.selectedWallet.wallet_type)
        if (wallet) {
          this.$set(this.app.selectedWallet, 'amount_limit', wallet.amount_limit)
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  },
  mounted() {
    this.updateClasses()
  },
  methods: {
    showModel(text) {
      this.limitText = text
      this.showModal = true
    },
    hideModel() {
      this.showModal = false
    },
    hideWalletModal() {
      this.showWallet = false
    },
    updateClasses() {
      this.upgradeDepositAmountClass = this.calculateClass(this.vipInfo.upgradeCurrentDepositAmount, this.vipInfo.upgradeNeedDepositAmount)
      this.performanceClass = this.calculateClass(this.vipInfo.upgradeCurrentPerformance, this.vipInfo.upgradeNeedPerformance)
    },
    calculateClass(current, target) {
      const formattedCurrent = parseInt(current)
      const formattedTarget = parseInt(target)
      if (formattedCurrent === 0 && formattedTarget === 0) {
        return 'check-off'
      }
      return formattedCurrent >= formattedTarget ? 'check-on' : 'check-off'
    },
    getWalletImagePath,
    getWalletBalance
  }
}
</script>

